import { Apollo } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AngularTokenService } from '@raysuelzer/angular-token';


import { clearCurrentUser } from '../_state/auth/auth-actions';
import { AuthState } from '../_state/auth/auth-state';
import { AppPersistantStateService, StoreNames } from '../core/state/app-state.service';
import { ToastrService } from 'core/toastr.service';

@Injectable({ providedIn: 'root' })
export class LogoffService {

  constructor(
    private tokenService: AngularTokenService,
    private toastrService: ToastrService,
    private router: Router,
    private appStateService: AppPersistantStateService,
    private store: Store<AuthState>,
    private apollo: Apollo) {
  }

  /**
   * Logs off user and performs cleanup
   */
  logoff() {
    const toastInstance = this.toastrService.info('Logging you out...');

    this.tokenService
      .signOut()
      .subscribe(
        () => {
          toastInstance?.dismiss();
        },
        () => {
          this.router.navigateByUrl('/login').then((r) => {
            this.clearAppState();
            this.apollo.client.clearStore();
            return r;
          });
        },
        () => {
          toastInstance?.dismiss();
          this.router.navigateByUrl('/login').then((r) => {
            this.clearAppState();
            this.apollo.client.clearStore();
          });
        });
  }

  private clearAppState() {
    this.store.dispatch(clearCurrentUser());
    this.appStateService.clear(
      StoreNames.Queries,
      StoreNames.CurrentCampaign,
    );
  }
}
